define('frontend-common-components/gettingStartedPanel/nls/root/gettingStartedPanel',{
    'gettingStarted':  {
        'panel': {
            'title': 'Getting Started'
        }
    }
});
